import React, { useState } from "react";
import "./OurServices.scss";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../context/LanguageContext";
import { photosApi } from "../../../SourceData";
import { useAuth } from "../../../context/AuthContext";
import Login from "../../Login/Login";


// Skeleton Component for Loading State
const ServiceCardSkeleton = () => {
  return (
    <div className="service-card service-card-skeleton">
      <div className="card-header">
        <div className="service-icon skeleton-loader"></div>
        <div className="service-title skeleton-loader"></div>
      </div>

      <div className="service-description skeleton-loader"></div>

      <div className="service-image skeleton-loader"></div>

      <div className="card-footer">
        <div className="more-btn skeleton-loader"></div>
      </div>
    </div>
  );
};

const OurServices = ({ categories, loading }) => {
  const { t, language } = useLanguage();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);

  // Function to get the appropriate name based on language
  const getCategoryName = (category) => {
    return language === "en" ? category.name.en : category.name.ar;
  };

  // Function to get description
  const getCategoryDescription = (category) => {
    if (category.description && category.description[language]) {
      return category.description[language];
    }
    return language === "en"
      ? `Professional ${category.name.en.toLowerCase()} services`
      : `خدمات ${category.name.ar} احترافية`;
  };

  // Handle service request click
  const handleServiceRequest = (categoryId) => {
    if (!user) {
      setShowLoginModal(true); // Open login modal if no user
    } else {
      navigate(`/services?category=${categoryId}`); // Navigate if user exists
    }
  };

  const handleLoginClose = () => {
    setShowLoginModal(false);
  };

  // Render loading state
  if (loading) {
    return (
      <div className="services-grid-section">
        <div className="container">
          <h2 className="section-title skeleton-loader"></h2>
          <p className="section-description skeleton-loader"></p>

          <div className="services-grid">
            {[...Array(3)].map((_, index) => (
              <ServiceCardSkeleton key={index} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Normal rendering when not loading
  return (
    <div className="services-grid-section">
      <div className="container">
        <h2 className="section-title">{t("ourServices")}</h2>
        <p className="section-description">{t("ourServicesDesc")}</p>

        {categories?.length === 0 ? (
          <div className="no-services">
            {language === "en"
              ? "No services available at the moment."
              : "لا توجد خدمات متاحة في الوقت الحالي."}
          </div>
        ) : (
          <div className="services-grid">
            {categories?.map((category) => (
              <div key={category.id} className="service-card">
                <div className="card-header">
                  <div className="service-icon">
                    <img
                      src={photosApi + category?.photo}
                      alt={getCategoryName(category)}
                      loading="lazy"
                    />
                  </div>
                  <h3 className="service-title">{getCategoryName(category)}</h3>
                </div>

                <p className="service-description">
                  {getCategoryDescription(category)}
                </p>

                <div className="service-image">
                  <img
                    src={photosApi + category?.photo}
                    alt={getCategoryName(category)}
                    loading="lazy"
                  />
                </div>

                <div className="card-footer">
                  <button
                    onClick={() => handleServiceRequest(category.id)}
                    className="more-btn"
                  >
                    {language === "en" ? "Request Service" : "اطلب الخدمة"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Login Modal */}
      {showLoginModal && (
        <Login open={showLoginModal} onClose={handleLoginClose} />
      )}
    </div>
  );
};

export default OurServices;